<template>
    <rkm-data-table
        :fields="fields.datatables.medicamento"
        :repository="repositories.medicamento"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(altaVigilancia)="{ item }">
            {{ item.altaVigilancia ? 'Sim' : 'Não' }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-medicamento-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-medicamento"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-medicamento"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    medicamento: [
                        {
                            name: 'nome',
                            key: 'nome',
                            label: 'Nome',
                            sortable: true,
                            searchable: true
                        },
                        {
                            key: 'altaVigilancia',
                            label: 'Alta vigilância',
                            class: 'col-min'
                        },
                        {
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            medicamento: this.getConectaSusRepository('cadastro.medicamento.medicamento')
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.medicamento.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o medicamento?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>